import React from "react";
import { Navigate } from "react-router-dom";
import { ADMIN_LOGIN_PATH } from "../admin/Adminpaths";
import AdminErrorBoundary from "../admin/Adminerrorboundary";

// Decodes a JWT payload WITHOUT verifying the signature (that's the
// server's job via requireAdmin.js on every API call). This is only for
// the client-side UX: deciding whether to bother rendering the admin
// screen at all, or send the user straight to the login page.
function decodeJwtPayload(token) {
  try {
    const base64Url = token.split(".")[1];
    if (!base64Url) return null;
    const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split("")
        .map((c) => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(jsonPayload);
  } catch {
    return null; // malformed/garbage token
  }
}

export default function ProtectedRoute({ children }) {
  const adminToken = localStorage.getItem("adminToken");

  // No token at all -> straight to login.
  if (!adminToken) {
    return <Navigate to={ADMIN_LOGIN_PATH} replace />;
  }

  const payload = decodeJwtPayload(adminToken);
  const nowInSeconds = Math.floor(Date.now() / 1000);

  // Token is malformed, expired, or doesn't carry the admin role ->
  // treat exactly like "not logged in": wipe it and go to login.
  // Without this check, a stale/garbage value sitting in localStorage
  // would still pass the old "does a string exist" test and let the
  // admin screen render (briefly) before any API call 401s.
  if (!payload || !payload.exp || payload.exp < nowInSeconds || payload.role !== "admin") {
    localStorage.removeItem("adminToken");
    return <Navigate to={ADMIN_LOGIN_PATH} replace />;
  }

  return <AdminErrorBoundary>{children}</AdminErrorBoundary>;
}